import React from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from 'components/Errors';
import Loader from 'components/Loader';

const ExpressCheckin = loadable(() => import(/* webpackChunkName: "ExpressCheckin" */ './ExpressCheckin'), {
  fallback: <Loader visible />,
});

const AsyncExpressCheckin = () => (
  <ErrorBoundary>
    <ExpressCheckin />
  </ErrorBoundary>
);

export default AsyncExpressCheckin;
